<div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 via-white to-primary-50/30 dark:from-luxury-navy dark:via-luxury-charcoal dark:to-luxury-navy px-4 py-8 animate-fade-in">
  <div class="w-full max-w-md">
    <div class="bg-white/95 dark:bg-luxury-navy/95 backdrop-blur-xl rounded-3xl shadow-luxury p-8 md:p-10 space-y-8 animate-scale-in border border-gray-200/50 dark:border-primary-800/20">
      <!-- Logo/Header -->
      <div class="text-center space-y-3">
        <div class="flex justify-center">
          <img
            src="assets/icons/icon-192x192.png"
            [alt]="companyName"
            class="w-16 h-16 rounded-2xl object-contain shadow-luxury-gold"
          />
        </div>
        <div>
          <h1 class="text-3xl md:text-4xl font-bold bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 dark:from-white dark:via-gray-100 dark:to-white bg-clip-text text-transparent mb-2">{{ companyName }}</h1>
          <p class="text-sm md:text-base text-gray-600 dark:text-gray-400 font-medium">Sign in to your premium account</p>
        </div>
      </div>

      <!-- Login Form -->
      <form (ngSubmit)="onSubmit()" class="space-y-6">
        <div class="space-y-2">
          <label for="username" class="block text-sm font-semibold text-gray-700 dark:text-gray-300">
            Username
          </label>
          <input
            type="text"
            id="username"
            [(ngModel)]="username"
            name="username"
            required
            class="w-full px-5 py-3.5 rounded-xl border-2 border-gray-200 dark:border-white/10 bg-white dark:bg-white/5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500/50 dark:focus:ring-primary-600/50 focus:border-primary-500 dark:focus:border-primary-600 transition-all duration-200 touch-manipulation"
            placeholder="Enter your username"
          />
        </div>

        <div class="space-y-2">
          <label for="password" class="block text-sm font-semibold text-gray-700 dark:text-gray-300">
            Password
          </label>
          <div class="relative">
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              [(ngModel)]="password"
              name="password"
              required
              class="w-full pl-5 pr-14 py-3.5 rounded-xl border-2 border-gray-200 dark:border-white/10 bg-white dark:bg-white/5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500/50 dark:focus:ring-primary-600/50 focus:border-primary-500 dark:focus:border-primary-600 transition-all duration-200 touch-manipulation"
              placeholder="Enter your password"
            />
            <button
              type="button"
              (click)="togglePasswordVisibility()"
              class="absolute inset-y-0 right-0 px-4 flex items-center justify-center text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 focus:outline-none"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
            >
              <svg
                *ngIf="!showPassword"
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5s8.268 2.943 9.542 7c-1.274 4.057-5.065 7-9.542 7S3.732 16.057 2.458 12z" />
              </svg>
              <svg
                *ngIf="showPassword"
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a9.956 9.956 0 012.042-3.368m2.244-1.89A9.953 9.953 0 0112 5c4.477 0 8.268 2.943 9.542 7a9.969 9.969 0 01-4.132 5.411M15 12a3 3 0 00-3-3m0 0a2.99 2.99 0 00-2.12.879M12 9l0 0m0 0L3 3m9 6l9 9" />
              </svg>
            </button>
          </div>
        </div>

        <button
          type="submit"
          [disabled]="isLoading"
          class="w-full py-3 px-5 bg-gradient-to-r from-primary-600 to-primary-700 dark:from-primary-600 dark:to-primary-800 hover:from-primary-700 hover:to-primary-800 dark:hover:from-primary-700 dark:hover:to-primary-900 text-white font-semibold rounded-lg transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] focus:outline-none focus:ring-4 focus:ring-primary-500/30 dark:focus:ring-primary-600/30 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none shadow-luxury-gold touch-manipulation ripple min-h-[40px]"
        >
          <span *ngIf="!isLoading" class="flex items-center justify-center">
            <span>Sign In</span>
            <svg class="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </span>
          <span *ngIf="isLoading" class="flex items-center justify-center">
            <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Signing in...
          </span>
        </button>
      </form>

      <!-- Default Credentials
      <div class="mt-8 p-4 bg-gradient-to-br from-gray-50 to-gray-100/50 dark:from-white/5 dark:to-white/5 rounded-xl border border-gray-200/50 dark:border-primary-800/20">
        <p class="text-xs text-gray-600 dark:text-gray-400 text-center font-medium">
          Default credentials: <strong class="text-gray-900 dark:text-white">admin</strong> / <strong class="text-gray-900 dark:text-white">admin123</strong>
        </p>
      </div>  -->
    </div>
  </div>
</div>



